import React from 'react';
import './Services.css';

const services = [
  {
    title: 'Why People Switch?',
    desc: '100% Natural, 100% Pure, 100% A2 Cow Milk with no additives.',
    image: '/choose1.jpeg',
  },
  {
    title: 'No Preservatives',
    desc: 'Delivered fresh every morning in eco-friendly reusable glass bottles.',
    image: '/choosebanner.jpeg',
  },
  {
    title: 'Conscious Choice',
    desc: 'Perfect for moms, fitness lovers, and busy professionals seeking purity.',
    image: '/choose3.jpeg',
  },
  {
    title: 'Purity Guaranteed',
    desc: 'No factory processing or plastic packaging concerns. Just real milk.',
    image: '/pack.jpeg',
  },
  {
    title: 'Wellness First',
    desc: 'Choose milk that chooses your well-being. Your body will thank you.',
    image: '/choose4.jpeg',
  },
  {
    title: 'Daily Freshness',
    desc: 'Every sip is a step towards wellness, delivered at your doorstep daily.',
    image: '/choose2.jpeg',
  },
];

const Services = () => {
  return (
    <section className="services-section py-5" id="gallery">
      <div className="container">
        {/* Header Section */}
        <div className="text-center mb-5">
          <h2 className="services-main-title text-white">
            Farm To Table <span className="gaubliisstext">Gaubliiss</span> A2 Cow Milk
          </h2>
          <div className="custom-divider mx-auto mt-3"></div>
        </div>
        
        {/* Responsive Grid */}
        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <div className="service-card">
                <div className="service-img-container">
                  <img src={service.image} alt={service.title} className="service-img" />
                </div>
                
                <div className="service-overlay">
                  <div className="service-content">
                    <h5 className="service-card-title">{service.title}</h5>
                    <p className="service-card-desc">{service.desc}</p>
                    <div className="service-line"></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;